import 'css-chunksrc/feature/auth-request/AuthRequestUIBlocker.module.scss';export default {
  "content_wrapper": "AuthRequestUIBlocker_content_wrapper",
  "form": "AuthRequestUIBlocker_form"
};